<template>
  <div class="login">
    <v-layout row justify-center>
      <v-flex xs12 sm6 md6 lg4>
        <v-card>

          <v-card-media :src="changeLogo()" :class="changeCssColor()" height="200px" contain>
          </v-card-media>

          <div class="backgroud-logo logo">
          </div>
          <v-card-title primary-title>
            <v-card-text>
              <p class="text-xs-center title primary--text">Recuperação de senha</p>

              <p class="text-xs-center title primary--text">
                Para recuperar sua senha de acesso, informe no campo abaixo o email utilizado no cadastro.
              </p>
              <v-form action="#" v-model="valid" ref="form" lazy-validation @submit.prevent="submit()">
                <v-text-field
                  label="E-Mail"
                  v-model="auth.username"
                  :rules="[v => !!v || 'Informe o e-mail cadastrado!']" required
                ></v-text-field>

                <v-btn
                  color = 'primary'
                  block
                  :disabled="!valid"
                  @click="submit()"
                >
                  Recuperar Senha
                </v-btn>
                <br><hr><br>
                <router-link to="/patient/login">
                  <v-btn block>Retornar para Login</v-btn>
                </router-link>

              </v-form>

            </v-card-text>
          </v-card-title>
          <v-card-actions>
            <div>
              <p>© 2017 - {{ new Date().getFullYear() }} <a href="http://www.spitzer.io">Spitzer.io</a> - Todos os direitos reservados</p>
              <p>Versão: {{getPkg.pkg.version}}</p>
            </div>
            <!-- <v-btn flat color="orange">Share</v-btn>
            <v-btn flat color="orange">Explore</v-btn> -->
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <v-snackbar
      :timeout="snackbarConfig.timeout"
      :color="snackbarConfig.color"
      :multi-line="snackbarConfig.mode === 'multi-line'"
      :vertical="snackbarConfig.mode === 'vertical'"
      v-model="snackbarConfig.snackbar"
    >
      {{ snackbarConfig.text }}
      <v-btn dark flat @click.native="snackbarConfig.snackbar = false">Fechar</v-btn>
    </v-snackbar>

  </div>
</template>


<script>
  import axios from 'axios'
  // import localforage from 'localforage'
  import { mapGetters } from 'vuex'
  import customersTheme from '../../../config/customersTheme'

  export default {
    name: 'Reset-password',
    computed: {
      ...mapGetters({
        customer: 'customer'
      }),
      ...mapGetters('app', ['getTheme', 'getPkg']),
      progress () {
        return Math.min(100, this.auth.password.length * 10)
      },
      color () {
        return ['error', 'warning', 'success'][Math.floor(this.progress / 40)]
      }
    },
    mounted () {
    },
    data: () => ({
      env: process.env.URL,
      snackbarConfig: {
        snackbar: false,
        color: 'error',
        mode: '',
        timeout: 6000,
        text: 'Erro de conexão com o servidor!'
      },
      valid: true,
      e1: true,
      p1: true,
      custom: true,
      auth: {
        username: ''
      }
    }),
    methods: {
      changeCssColor () {
        const customerTheme = customersTheme[localStorage.getItem('riscSchedulePatientCustomer')]
        // console.log(customerTheme.cssClass)
        return customerTheme.cssClass
      },
      changeLogo () {
        const customerTheme = customersTheme[localStorage.getItem('riscSchedulePatientCustomer')]
        return customerTheme.logo
      },
      changeColorHTML () {
        const customerTheme = customersTheme[localStorage.getItem('riscSchedulePatientCustomer')]
        return customerTheme.colorHTML
      },
      submit () {
        if (this.$refs.form.validate()) {
          axios.post(process.env.URL + '/schedule-online/auth/patient/forget-password', {
            username: this.auth.username.toLowerCase()
          }, {
            params: {
              customer: this.customer
            }
          }).then((response) => {
            this.$router.push('/')
          }).catch((err) => {
            window.console.log(err.response)
            if (err.response.data.message) {
              this.snackbarConfig.snackbar = true
              this.snackbarConfig.text = err.response.data.message
              return false
            }
            if (err.response.data.errors) {
              if (err.response.data.errors.username) {
                window.console.log(err.response.data.errors.username.msg)
                this.snackbarConfig.text = err.response.data.errors.username.msg
                this.snackbarConfig.snackbar = true
                return false
              }
            }
            this.snackbarConfig.snackbar = true
            this.snackbarConfig.text = err.response.data.result.error
          })
        }
      }
    }
  }
</script>





// WEBPACK FOOTER //
// src/views/auth/Forget-password.vue